export default "__VITE_ASSET__CgW9zvkv__"